exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-tooltip-with-info.info-icon{cursor:pointer;color:#b3bac5}\n", ""]);

// exports
